<template>
  <box-node class="gap-2">
    <div class="d-flex flex-column gap-1">
      <span class="font-weight-bold">Setor</span>
      <span class="font-size-14">Selecione o setor que o tratamento será retirado.</span>
    </div>
    <v-radio-group v-model="modelValue" class="custom-radio-group" hide-details>
      <v-radio value="private">
        <template #label>
          <div class="d-flex flex-column gap-3">
            <span>Privado (operadora de saúde)</span>
            <span v-if="modelValue == 'private'">
              No setor privado, para liberação do biológico, o paciente precisa ter apresentado TRÊS ou mais
              exacerbações em um ano e eosinófilos no sangue periférico acima de 300 células/μL. Para reforçar a
              justificativa do pedido do medicamento, inclua detalhes de cada exacerbação e sugira que o paciente anexe
              as documentações referentes a essas exacerbações, caso as tenha. Exemplo: A primeira exacerbação aconteceu
              em 04/04/2024 após esforço físico em aula de musculação.
            </span>
          </div>
        </template>
      </v-radio>
      <v-radio value="public">
        <template #label>
          <div class="d-flex flex-column gap-3">
            <span>Público (farmácia de alto custo do SUS)</span>
            <span v-if="modelValue == 'public'">
              No setor público, para liberação do biológico, o paciente precisa ter apresentado UMA ou mais exacerbação
              em um ano e eosinófilos no sangue periférico acima de 300 células/μL. Para reforçar a justificativa do
              pedido do medicamento, inclua detalhes de cada exacerbação e sugira que o paciente anexe as documentações
              referentes a essas exacerbações, caso as tenha. Exemplo: A primeira exacerbação aconteceu em 04/04/2024
              após esforço físico em aula de musculação.
            </span>
          </div>
        </template>
      </v-radio>
      <v-radio label="Gerar relatório, independente da via de acesso" value="none" />
    </v-radio-group>
  </box-node>
</template>

<script>
import { ComputedOptions } from 'vue'
import BoxNode from '@/components/NewAttendanceForm/FormNodes/Box/BoxNode.vue'

export default {
  components: { BoxNode },
  props: {
    value: {
      type: String,
    },
  },
  computed: {
    /** @type {ComputedOptions<string>} */
    modelValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style scoped>
.custom-radio-group {
  margin: 0;
  padding: 0;
}

.custom-radio-group .v-radio {
  padding: 12px;
  margin: 0 !important;
  column-gap: 4px;
  align-items: start;
}

.custom-radio-group .v-radio :deep(.v-label) {
  color: var(--v-neutral-lighten17);
  font-size: 14px;
  padding-top: 2px;
}
</style>
